import { IconChevron } from '../../Icon'

import ChevronDown from '../../../icons/unique/ai/chevron-down.svg'

function ProfileAISummaryWidgetArrowIcon({ ref, ...props }) {
  return <IconChevron {...props} Icon={ChevronDown} ref={ref} />
}

export default ProfileAISummaryWidgetArrowIcon
